// ECMJ 프로그램 아이디 : REQ_대한항공 적립몰_01_01 (jg26.kim)
import React from 'react';

// import { openWindow } from '@ecp/common/src/utils/utils';
import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';

import {
  Container,
  InfoTextBox,
  KoreanAirSavingsFooterSubNoticeContainer,
  TextBold,
} from '@ecp/mo/sites/koreanairSavings/styles/footer/KoreanAirSavingsFooterNoticeStyles';

export default function KoreanAirSavingsFooterNotice() {
  // const { isMobileApp, agentType } = useRecoilValue(withMobileStatus);

  // function onClickCurrentMilage() {
  //   openWindow(isMobileApp, 'https://www.koreanair.com/my-mileage/overview', '_blank', agentType);
  // }

  return (
    <Container>
      <FlexBoxColumn align-items={'flex-start'}>
        <InfoTextBox size={'18px'} weight={'500'} height={'28px'}>
          대한항공 마일리지 적립몰 안내사항
        </InfoTextBox>
        <Spacing top={'4px'} />
        <KoreanAirSavingsFooterSubNoticeContainer>
          {/*<InfoTextBox size={'11px'}>*/}
          {/*  <TextBold>•</TextBold>구매 전 보유 마일리지를 확인해주시기 바랍니다.{' '}*/}
          {/*  <InfoTextBox size={'11px'} onClick={onClickCurrentMilage} isEmphasize>*/}
          {/*    마일리지 현황&gt;*/}
          {/*  </InfoTextBox>*/}
          {/*</InfoTextBox>*/}
          <InfoTextBox size={'11px'}>
            <TextBold>-</TextBold>마일리지 적립을 위해서는 SKYPASS 회원가입이 필요하며 개인정보 수집 및 이용에 동의가
            필요합니다.
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold>-</TextBold>대한항공 홈페이지 로그인 후 적립몰을 이용하는 경우 마일리지는 배송 완료일 기준 익월 말
            로그인한 회원의 SKYPASS 계정으로 자동 적립됩니다.
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold></TextBold>(예) 10/1 ~ 10/31 배송 완료 건 : 11월 마지막주 적립
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold>-</TextBold>마일리지는 부가세 제외한 최종 지불 금액 기준 1,000원당 1마일리지가 적립되며, 1,000원
            미만의 금액은 절사됩니다.
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold>-</TextBold>적립이 완료된 마일리지는 적립 취소 및 현금 환급 등이 불가합니다. 배송 완료 후 구매
            취소 및 환불 시 적립된 마일리지는 회수될 수 있습니다.
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold>-</TextBold>제품 관련 문의사항은 고객센터(1800-7837)로 연락 바랍니다.
          </InfoTextBox>
        </KoreanAirSavingsFooterSubNoticeContainer>
      </FlexBoxColumn>
    </Container>
  );
}
